// removes an element from the document
const hideDocumentElement = (elementId: string) => {
  let element = document.getElementById(elementId);

  if (element) {
    element.style.display = 'none';
  }
};

/**
 * This funciton adds a click event to an element based off its element id
 * When that element is clicked, this function removes the specified parent container
 * It then adds the same click event to the linkElementB and containerElementB
 * it continues to cycle between these links and containers unless no element can be found
 *
 * @param linkElementIdA - Adds a click event to this element
 * @param containerElementIdA - This element will be hidden after the linkElementA param is clicked
 * @param linkElementIdB - This element will have a click event on every other click
 * @param containerElementIdB - This element will be removed on every other click
 */
export const addRecursiveClickEvent = (
  linkElementIdA: string,
  containerElementIdA: string,
  linkElementIdB: string,
  containerElementIdB: string,
): void => {
  setTimeout(() => {
    const linkElement = document.getElementById(linkElementIdA);

    if (linkElement) {
      linkElement.addEventListener('click', function () {
        hideDocumentElement(containerElementIdA);
        addRecursiveClickEvent(
          linkElementIdB,
          containerElementIdB,
          linkElementIdA,
          containerElementIdA,
        );
      });
    }
  }, 0);
};
